import { render, staticRenderFns } from "./addEmptycode.vue?vue&type=template&id=5affd10a&"
import script from "./addEmptycode.vue?vue&type=script&lang=js&"
export * from "./addEmptycode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports